module.exports = __webpack_public_path__ + "static/media/squares-orange.61fb4e66.svg";